<script setup lang="ts">

import { TimeSeriesS } from '../fin/history';
import AssetTimePlot from './AssetTimePlot.vue';
import FlowTimePlot from './FlowTimePlot.vue';

interface Props {
  assetTimeSeries: TimeSeriesS<number>;
  flowTimeSeries: TimeSeriesS<number>;
  birthYear: number;
  retirementYear: number;
  exhausted: string;
  exhaustionYear: string;
  exhaustionAge: string;
  maxYear: number;
}

const props = withDefaults(defineProps<Props>(), {
  assetTimeSeries: () => new TimeSeriesS<number>([]),
  flowTimeSeries: () => new TimeSeriesS<number>([]),
  birthYear: 0,
  retirementYear: 0,
  exhausted: '',
  exhaustionYear: '',
  exhaustionAge: '',
  maxYear: 0,
});

</script>

<template>
  <div class=output-card>
    <table><tbody>
      <tr>
        <td> exhausted </td>
        <td id="fin-output-value-exhausted"
            title="Did you run out of money before your specified maximum age?"
          > {{exhausted}} </td>
      </tr><tr>
        <td> exhaustion year </td>
        <td id="fin-output-value-exhaustionYear"
            title="When the money runs out. If blank (and 'exhausted' is true), then max age is set too young, so the simulation finishes before it can use up your savings."
          > {{exhaustionYear}} </td>
      </tr><tr>
        <td> exhaustion age </td>
        <td id="fin-output-value-exhaustionAge"
            title="Age when the money runs out. If blank (and 'exhausted' is true), then max age is set too young, so the simulation finishes before it can use up your savings."
          > {{exhaustionAge}} </td>
      </tr>
    </tbody></table>
  </div>
  <AssetTimePlot
    :timeseriess="props.assetTimeSeries"
    :birthYear="props.birthYear"
    :retirementYear="props.retirementYear"
    :maxYear="props.maxYear" />
  <FlowTimePlot
    :timeseriess="props.flowTimeSeries"
    :birthYear="props.birthYear"
    :retirementYear="props.retirementYear"
    :maxYear="props.maxYear" />
</template>

<style scoped>
</style>
